import { lazy } from 'react'
import BasicLayout from '@/components/layout/BasicLayout'
import type { RouteConfig } from '@/router/index'
import { UI_TEST_ROUTE_PATH, UI_TEST_RUN_ROUTE_PATH } from '@/modules/ui-test/constants'

/** Đăng ký route trang test thao tác UI — gọi cuối `generateRoutes`. */
export const appendUiTestRoutes = (routes: RouteConfig[]): void => {
  routes.push({
    path: UI_TEST_ROUTE_PATH,
    name: 'UiTest',
    exact: true,
    layout: BasicLayout,
    component: lazy(() => import('@/modules/ui-test/UiTestPage')),
    title: 'DEV TEST',
  })
  routes.push({
    path: UI_TEST_RUN_ROUTE_PATH,
    name: 'UiTestRun',
    exact: true,
    layout: BasicLayout,
    component: lazy(() => import('@/modules/ui-test/UiTestRunPage')),
    title: 'DEV TEST',
  })
}
